import {
    GESTION_OPERATIVA_CLEAR_PATENTE,
  } from './constants';
  
  export function clearPatente() {
      return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_CLEAR_PATENTE,
            data: {
              patenteError: "",
              patenteCodeError: undefined,
              isValidLicensePlate:false
            }
        })
      }
  }
  
  export function reducer(state, action) {
    if (action.type === GESTION_OPERATIVA_CLEAR_PATENTE) {
        return {
          ...state,
          ...action.data
        };
    }
    else{
        return state;
    }        
  }
  